module.exports = __webpack_public_path__ + "img/province-institutions.2a677d2f.png";